<template>
  <div class="">
  <Modal
    v-model="editListModal"
    width="700"
    title="报备客户"
    :mask-closable="false"
    :loading="loading"
    @on-ok="editList('editListForm')"
  >
    <Form
      ref="editListForm"
      label-position="right"
      :label-width="120"
      :rules="ruleValidate"
      :model="editListForm"
    >
      <FormItem label="企业名称"
        prop="enterpriseName"
        label-for="enterpriseName"
      >
        <Input
          placeholder="请输入企业名称"
          element-id="enterpriseName"
          v-model="editListForm.enterpriseName"
        ></Input>
      </FormItem>
      <FormItem label="CorpID"
        prop="corpid"
        label-for="corpid"
      >
        <Input
          placeholder="请输入CorpID"
          element-id="corpid"
          v-model="editListForm.corpid"
        ></Input>
      </FormItem>
      <FormItem label="联系人"
        prop="name"
        label-for="name"
      >
        <Input
          placeholder="请输入联系人"
          element-id="name"
          v-model="editListForm.name"
        ></Input>
      </FormItem>
      <FormItem label="手机号码"
        prop="phone"
        label-for="phone"
      >
        <Input
          placeholder="请输入手机号码"
          element-id="phone"
          v-model="editListForm.phone"
        ></Input>
      </FormItem>
      <FormItem label="所属地区"
        label-for="addrVal"
      >
      <AsyncCascader
        url="/area/list"
        placeholder="请选择地址"
        :value="addrVal"
        :level="2"
        @on-change="addrChange"
      />
      </FormItem>
      <FormItem label="所属行业"
        prop="industryType"
        label-for="industryType"
      >
        <Select
          clearable
          filterable
          element-id="industryType"
          class="search-input"
          placeholder="请选择所属行业"
          v-model="editListForm.industryType"
        >
          <Option
            v-for="orderType in busType"
            :key="orderType.value"
            :value="orderType.value+''"
          >{{orderType.name}}</Option>
        </Select>
      </FormItem>
   </Form>
</Modal>
</div>
</template>

<script>
import AsyncCascader from '@/components/AsyncCascader'

export default {
  components: {
    AsyncCascader
  },
  props: {
    editReportCurstom: {
      type: Boolean,
      required: true
    }
  },
  data () {
    const validateMobile = (rule, value, callback) => {
      if (!value.match(/[0-9-()（）]{7,15}/)) {
        callback(new Error('请输入正确的联系电话类型'))
      } else {
        callback()
      }
    }
    return {
      busType: [],
      addrVal: [],
      sysroleList: [],
      isEdit: true,
      loading: true,
      editListForm: {
        enterpriseName: '',
        corpid: '',
        name: '',
        phone: '',
        provId: '',
        cityId: '',
        industryType: ''
      },
      editListModal: this.editReportCurstom,
      // 表单验证
      ruleValidate: {
        enterpriseName: [
          { required: true, message: '请输入企业名称', type: 'string', trigger: 'blur' }
        ],
        corpid: [
          { required: true, message: '请输入corpID', type: 'string', trigger: 'blur' }
        ],
        name: [
          { required: true, message: '请输入联系人', trigger: 'blur' }
        ],
        phone: [
          { required: true, message: '请输入手机号', trigger: 'change' },
          { validator: validateMobile, trigger: 'blur' },
          { max: 13, message: '请正确的联系电话', trigger: 'blur' }
        ],
        industryType: [
          { required: true, message: '请选择所属行业', trigger: 'change' }
        ]
      }
    }
  },
  watch: {
    editReportCurstom (val) {
      this.editListModal = val
      if (val) {
        this.reload()
      } else {
        this.$refs.editListForm.resetFields()
        this.addrVal = []
      }
    },
    editListModal (val) {
      if (!val) {
        this.$emit('backeditModal')
      }
    }
  },
  methods: {
    // 保存编辑数据
    editList (val) {
      this.loading = false
      setTimeout(() => {
        this.loading = true
      }, 50)
      this.$refs[val].validate((valid) => {
        if (valid) {
          let data = {
            ...this.editListForm
          }
          let url = '/customer'
          this.$http.post(url, data).then(res => {
            if (res.success) {
              let msg = '新增成功'
              this.$Message.success(msg)
              this.editListModal = false
              this.$emit('callback')
            } else {
              this.$Message.error(res.message)
            }
          })
        }
      })
    },
    reload () {
      this.editListForm = {
        enterpriseName: '',
        corpid: '',
        name: '',
        phone: '',
        loginName: '',
        industryType: '',
        provId: '',
        cityId: ''
      }
    },
    addrChange (val) {
      this.editListForm.provId = val[0]
      this.editListForm.cityId = val[1]
    },
    // 修改密码
    resetPassword (val) {
      this.loading = false
      setTimeout(() => {
        this.loading = true
      }, 50)
      this.$refs[val].validate((valid) => {
        if (valid) {
          let data = {
            password: this.resetLostForm.password,
            id: this.editListForm.id
          }
          let url = '/user'
          this.$http.put(url, data).then(res => {
            if (res.success) {
              let msg = '重置密码成功'
              this.$Message.success(msg)
              this.$emit('callback')
              this.visible = false
              this.editListModal = false
              this.resetLostForm.password = ''
            } else {
              this.$Message.error(res.message)
            }
          })
        }
      })
    }
  },
  created () {
    this.$http.get('/dropdown/industry').then(res => {
      this.busType = res.data
    })
  }
}
</script>

<style lang="css">
</style>



// WEBPACK FOOTER //
// src/pages/customManage/agCustomList/ReportCurstom.vue